import { DateRange } from '@/models';
import moment from 'moment';
import Vue from 'vue';
import Datepicker from 'vuejs-datepicker';

export const dateRangeMixin = Vue.extend({
  components: {
    Datepicker,
  },
  data() {
    return {
      form: {
        startDate: null as unknown as Date,
        endDate: null as unknown as Date,
      },
      dateRange: null as unknown as DateRange,
    };
  },
  computed: {
    datesUntilToday(): DateRange {
      return { to: moment().startOf('day').toDate() };
    },
    datesUntilStartDate(): DateRange {
      return this.form.startDate ? { to: this.form.startDate } : this.datesUntilToday;
    },
    calendarOpenDate(): Date {
      return this.form.endDate ? this.form.endDate : this.form.startDate;
    },
  },
  methods: {
    markDateRange() {
      setTimeout(() => {
        if (this.form.startDate && this.form.endDate) {
          this.dateRange = { from: this.form.startDate, to: this.form.endDate };
        } else {
          this.dateRange = null as unknown as DateRange;
        }
      });
    },
    isStartDateAfterEndDate(): boolean {
      return moment(this.form.startDate).startOf('day').isAfter(moment(this.form.endDate).startOf('day'));
    },
    validateEndDate() {
      setTimeout(() => {
        if (this.isStartDateAfterEndDate()) {
          this.form.endDate = null as unknown as Date;
          this.markDateRange();
          (this.$refs.endDate as any).showCalendar();
        }
      });
    },
    getDateRange(prop: 'start' | 'end'): DateRange | { dates: Date[] } {
      const rangeMap = { start: this.form.startDate, end: this.form.endDate };
      if (this.dateRange) {
        return this.dateRange;
      }
      return rangeMap[prop] ? { dates: [rangeMap[prop]] } : { dates: [] };
    },
  },
});
